module.exports = __webpack_public_path__ + "assets/Epsilon.8c12b3624f6ce0ec96fff6e28e218626.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/png/packs2x/Epsilon.png
// module id = 832
// module chunks = 0